import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import CenteredColumnGrid from "components/styled/CenteredColumnGrid";
import React, { useContext } from "react";
import CopyrightStatement from "components/CopyrightStatement/CopyrightStatement";
import Header from "components/Header/Header";
import InfiniteSlider from "components/ui/InfiniteSlider/InfiniteSlider";
import { PAGES } from "utils/constants";
import { PageContext } from "utils/PageContext";
import SpotifyLogo from "components/SpotifyLogo/SpotifyLogo";
import COMPIcon from "components/COMPIcon.png";

function Homepage() {
  const { setPage } = useContext(PageContext);

  const mainTheme = useTheme();

  return (
    <>
      <Header />
      <Box
        component="main"
        sx={{
          marginTop: "3rem",
          height: "100%",
          textAlign: "center",
          paddingBottom: "5rem",
        }}
      >
        <CenteredColumnGrid container>
          <Grid item>
            <Typography
              component="h1"
              variant="h2"
              sx={{
                color: mainTheme.palette.whitePrimary.main,
                textShadow: `4px 2px ${mainTheme.palette.darkPurplePrimary.main},
                   6px 4px ${mainTheme.palette.darkBluePrimary.main},
                   8px 6px ${mainTheme.palette.darkPinkPrimary.main},
                   10px 8px ${mainTheme.palette.greenPrimary.main}`,
                padding: "0.5rem 0",
                fontWeight: 800,
                fontStyle: "italic",
                WebkitTextStroke: `1.5px ${mainTheme.palette.blackPrimary.main}`,
              }}
            >
              COMP Score Generator
            </Typography>
          </Grid>

          <Grid item>
            <InfiniteSlider />
          </Grid>

          <Grid item>
            <Box
              sx={{
                margin: "auto",
                position: "relative",
                width: "21rem",
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  padding: "1rem 0",
                  margin: "0 30px",
                  fontStyle: "bold",
                }}
              >
                Music is about connection. No judgement. No critique. Your music
                taste. Your COMP Score.
              </Typography>
            </Box>
          </Grid>

          <Grid item>
            <Button
              onClick={() => {
                setPage(PAGES.SEARCH);
              }}
              sx={{
                bgcolor: mainTheme.palette.darkBluePrimary.main,
              }}
            >
              Let's Score
            </Button>
            <div style={{ margin: "20px" }}>
              <img
                src={COMPIcon}
                alt="COMP Icon"
                style={{
                  width: "13%",
                  height: "13%",
                  minWidth: "50px",
                  minHeight: "50px",
                  maxWidth: "75px",
                  maxHeight: "75px",
                }}
              />
            </div>
            <SpotifyLogo />
          </Grid>
        </CenteredColumnGrid>
      </Box>
      <CopyrightStatement />
    </>
  );
}

export default Homepage;
